import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import {db} from '../../../../firebaseConfig';

import { doc, updateDoc } from "firebase/firestore";

import { useNavigate } from 'react-router-dom';

import { CircularProgress, Box } from "@mui/material";

export default function CheckoutCancelled() {

  const [params] = useSearchParams();
  const accountNumber = params.get("accountNumber");

  const plan = params.get("plan");

  const frequency = params.get("frequency");

  const navigate = useNavigate();

  useEffect(() => {
    // You can call your backend to confirm the session, store subscription, etc.
    console.log("Checkout cancelled. accountNumber:", accountNumber);


  const fetchSessionDetails = async () => {
    try {

      if (accountNumber !== null && accountNumber !== "")
      {

        try {
          const docRef = doc(db, "appAccounts", accountNumber);
      
          await updateDoc(docRef, {
            dodoCheckoutProcessStatus: "cancelled",
          });
      
          navigate(`/subscribe?plan=${plan}&frequency=${frequency}`)

        //   console.log(`/subscribe?plan=${plan}&frequency=${frequency}`);
          
          console.log("Subscription status updated to 'cancelled'.");
        } catch (error) {
          console.error("Failed to update appAccounts record:", error);
        }

      }

      // Do something with sessionInfo
    } catch (error) {
      console.error("Error updating account record:", error);
    }
  };

  if (accountNumber) {
    fetchSessionDetails();
  }

}, [accountNumber]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f9f9f9'
      }}
    >
      {<CircularProgress />}
    </Box>
  );
}
